import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import { homeCarePartnerNameFor } from "@sp-crm/core";
import { ExternalRecordLink } from "components/home-care-leads/send-to-partner/external-record-link";
import React from "react";
import { EntityActivitySummary } from "./details/entity-activity-summary";
import { EntityActivityEntryProps } from "./types";

export const EntityActivitySentToPartner: React.FC<EntityActivityEntryProps> = props => {
    const { activity } = props;
    const event = activity.activity.metadata?.events?.find(
        e => e.type === "SentToPartner",
    );
    const integration = event?.sentToPartner?.integration;
    const url = event?.sentToPartner?.url;
    const partnerName = integration
        ? homeCarePartnerNameFor(integration)
        : "a partner system";

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <PaperAirplaneIcon
                        className="h-5 w-5 text-gray-500"
                        aria-hidden="true"
                    />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    sent this home care client to <strong>{partnerName}</strong>.
                </EntityActivitySummary>
                {url ? (
                    <div className="mt-2 text-sm">
                        <ExternalRecordLink url={url} partnerName={partnerName} />
                    </div>
                ) : null}
            </div>
        </div>
    );
};
